import React,{useState,useEffect} from 'react';
import ImageUploader from './ImageUploader';
import './css/EditAccount.css';
//redux
import { useSelector, useDispatch} from 'react-redux';
import {setLoginStatus, setPhoto, setUserName,setReduxUserID } from "./redux/isLoggedIn";
import {setFirstAppLoad } from "./redux/firstAppLoad";
import ReAuthenticatePopup from './ReAuthenticatePopup';
import NameChangePopup from './NameChangePopup';

//firebase stuff
import {firebase} from './firebase';
import {collectionRef, db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs,updateDoc, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import {getAuth, createUserWithEmailAndPassword,signOut,signInWithEmailAndPassword,updateProfile} from 'firebase/auth';


function EditAccount() {

     const auth = getAuth();
     const user = auth.currentUser;

     const reduxFirstAppLoad = useSelector((state) => state.firstAppLoad.reduxFirstAppLoad);
     const reduxIsLoggedIn = useSelector((state) => state.isLoggedIn.reduxIsLoggedIn);
     const reduxUserName = useSelector((state) => state.isLoggedIn.reduxUserName);
     const reduxUserPhoto = useSelector((state) => state.isLoggedIn.reduxUserPhoto);
     const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);
     const reduxFlameOn = useSelector((state) => state.rallyTracker.reduxFlameOn);
     
     var emailGrab;
     const [name,setName] = useState(reduxUserName);
     const [email,setEmail] = useState('');
     const [originalEmail,setOriginalEmail] = useState('');
     const [showReLoginAuthPopup,setShowReLoginAuthPopup ] = useState(false);
     
     const [showNameChangePopup,setShowNameChangePopup] = useState(false);
     const [nameChangeLoading, setNameChangeLoading] = useState(false); 

     auth.onAuthStateChanged( (user) => {
          if(user){
               emailGrab = user.email;
          }
          else{
    
          }
     })


     const updateUserEmail = () => {
          if(email != '' && email != null){
               //update DB just for the hell of it. i dont think we ever use the value
               const emailRef = doc(db,"users",reduxUserID);
               updateDoc(emailRef, { email: email });
               //this opens the popup which allows for the password reAuth and changing of the FB user email value
               setShowReLoginAuthPopup(true);
          }
          else{
               setEmail(originalEmail);
          }

      }


     useEffect(() => {
          if(user != undefined){
             setEmail(user.email);  
             setOriginalEmail(user.email); 
          }
              
     }, [user])
    

     const changeName = () => {

          if(name != '' && name != null){
               setNameChangeLoading(true);
               //update DB just for the hell of it. i dont think we ever use the value
               const nameRef = doc(db,"users",reduxUserID);
               updateDoc(nameRef, { name: name });
               
               //by changing the displayName, the reduc value gets changed as well
               updateProfile(user, {
                    displayName: name
                    
               }).then(() => {
                    console.log("user.name: " + user.displayName);
                    setShowNameChangePopup(true);
                    setNameChangeLoading(false);
               }).catch((error) => {
                    console.log(error);
               });   
          }else{
               setName(user.displayName);
          }
     }





     return (
          <div className='editContainer'>
               {showReLoginAuthPopup &&
                    <ReAuthenticatePopup originalEmail={originalEmail} email={email} setShowReLoginAuthPopup={setShowReLoginAuthPopup}  />
               }
               
               {showNameChangePopup &&
                    <NameChangePopup username={user.displayName} setShowNameChangePopup={setShowNameChangePopup}  />
               }       


               <div className='row imageUploadArea'>
                    <ImageUploader  />
               </div>

               <div className='row'>
                    {/* <p>Edit your name</p> */}
                    <input type='text' value={name} 
                         placeholder={ "name"}
                         className={'textfield'}
                         onChange = {(event) => setName(event.target.value)} 
                    />
                    <button className='textEditButton' onClick={changeName}>
                         <div className={ nameChangeLoading ? 'loading' : ''}></div>
                         Edit
                    </button>

                    
               </div>

               <div className='row'>
                    {/* <p>Edit your name</p> */}
                    <input type='text' value={email} 
                         placeholder={ "email"}
                         className={'textfield'}
                         onChange = {(event) => setEmail(event.target.value)} 
                         
                    />
                    <button className='textEditButton' onClick = {updateUserEmail}>Edit</button>
               </div>



             
          </div>
     )
}

export default EditAccount
